import { base_url } from "./Blogs";
export async function getCategories() {
  try {
    const response = await fetch(`${base_url}/blog-categories`);
    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Fetch error:", err);
    return {};
  }
}
